import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface IStyleProps {
  radius?: number
}

export const Container = styled.div`
  width: 100%;
  flex-direction: column;
  align-items: center;
`
export const SvgContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
`
export const Indicator = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const BigMenuContainer = styled.div`
  flex-direction: row;
  display: flex;
  margin: 60px 0 0 0;
  align-items: center;
  justify-content: space-around;
  /* width: 100%; */
`

export const MenuContainer = styled.div`
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-left: 10px;
`

export const Dot = styled.div`
  height: 10px;
  width: 10px;
  border-radius: 50px;
  background-color: ${Theme.pallete.PRIMARY};
`
export const Svg = styled.svg`
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
  border-radius: ${(props: IStyleProps) =>
    props.radius ? props.radius * 2 : 0}px;

  svg .animation-circle {
    transition: stroke-dashoffset 1s;
  }
`
